import styled from 'styled-components';
import { Box } from '@components/common';

const DesktopContainer = styled(Box)`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex: 1;
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    padding: 64px 12px 0px 12px;
    justify-content: flex-start;
    align-items: flex-start;
  }
  @media screen and (min-width: 1024px) {
    padding: 64px 24px 0px 24px;
    justify-content: flex-start;
    align-items: flex-start;
  }
  @media screen and (max-width: 767px) {
    width: 100%;
    max-width: 345px;
    flex-direction: column;
    justify-content: center;
  }
`;

export default DesktopContainer;
